import React from "react";
import { useTranslation } from "react-i18next";
import {
  SidebarContainer,
  FilterGroup,
  FilterTitle,
  FilterOption,
  FilterToggleGroup,
  FilterToggleLabel,
  FilterToggleSwitch
} from "./Sidebar.styled";
import { ActionsGlobalMediaLibrary } from "../../../../Actions/ActionsGlobalMediaLibrary/ActionsGlobalMediaLibrary";
import { isFilterActive } from "../../utils/filterUtils";

const Sidebar = ({ filters }) => {
  const { t } = useTranslation();

  const handleMediaTypeFilter = (mediaType) => {
    ActionsGlobalMediaLibrary.toggleFilter({ filterType: "mediaType", value: mediaType });
  };

  const handleRatioFilter = (ratio) => {
    ActionsGlobalMediaLibrary.toggleFilter({ filterType: "ratio", value: ratio });
  };

  const handleShowKPIsToggle = () => {
    ActionsGlobalMediaLibrary.setShowKPIs(!filters?.showKPIs);
  };

  const handleShowOnlyFavoritesToggle = () => {
    ActionsGlobalMediaLibrary.setShowOnlyFavorites(!filters?.showOnlyFavorites);
  };

  return (
    <SidebarContainer>
      <FilterGroup>
        <FilterTitle>{t("Media type")}</FilterTitle>
        <FilterOption
          className={isFilterActive(filters?.mediaType, "images") ? "active" : ""}
          onClick={() => handleMediaTypeFilter("images")}
          type="button"
        >
          {t("Images")}
        </FilterOption>
        <FilterOption
          className={isFilterActive(filters?.mediaType, "videos") ? "active" : ""}
          onClick={() => handleMediaTypeFilter("videos")}
          type="button"
        >
          {t("Videos")}
        </FilterOption>
      </FilterGroup>
      <FilterGroup>
        <FilterTitle>{t("Ratio")}</FilterTitle>
        <FilterOption
          className={isFilterActive(filters?.ratio, "landscape") ? "active" : ""}
          onClick={() => handleRatioFilter("landscape")}
          type="button"
        >
          {t("Landscape")}
        </FilterOption>
        <FilterOption
          className={isFilterActive(filters?.ratio, "portrait") ? "active" : ""}
          onClick={() => handleRatioFilter("portrait")}
          type="button"
        >
          {t("Portrait")}
        </FilterOption>
        <FilterOption
          className={isFilterActive(filters?.ratio, "16:9") ? "active" : ""}
          onClick={() => handleRatioFilter("16:9")}
          type="button"
        >
          16:9
        </FilterOption>
      </FilterGroup>
      <FilterToggleGroup>
        <FilterTitle>{t("Filters")}</FilterTitle>
        <FilterToggleLabel>
          <input
            type="checkbox"
            checked={!!filters?.showOnlyFavorites}
            onChange={handleShowOnlyFavoritesToggle}
            style={{ display: "none" }}
          />
          <FilterToggleSwitch aria-hidden="true" />
          {t("Only Favorites")}
        </FilterToggleLabel>
        <FilterToggleLabel>
          <input
            type="checkbox"
            checked={!!filters?.showKPIs}
            onChange={handleShowKPIsToggle}
            style={{ display: "none" }}
          />
          <FilterToggleSwitch aria-hidden="true" />
          {t("Show KPIs")}
        </FilterToggleLabel>
      </FilterToggleGroup>
    </SidebarContainer>
  );
};

export default Sidebar;
